import React from 'react';
import { Accent } from './SectionHeading';
import { bonuses } from '../../data/content';

/** Bonuses as text — deliberately lighter than the core volumes. */
export function BonusesSection() {
  return <section aria-labelledby="bonus-heading" className="border-t border-brand-plum/10 bg-brand-lavender px-5 py-16 lg:px-8 lg:py-24" data-id="element-40" data-mp="16m0wdivawbfu">
      <div className="mx-auto max-w-4xl" data-id="element-41" data-mp="1bi7r0fi8y0ih">
        <div className="mx-auto max-w-2xl text-center" data-id="element-42" data-mp="wms5iyvqfcxp">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold" data-id="element-43" data-mp="wp5vitbk1yye">
            Et ce n’est pas tout…
          </p>
          <h2 id="bonus-heading" className="mt-4 font-display text-[2.1rem] font-bold leading-[1.08] text-brand-charcoal sm:text-[2.75rem]" data-id="element-44" data-mp="nneuw2vvgibe">
            Recevez également <Accent data-id="element-45" data-mp="2i04laan179e1">5 ressources supplémentaires.</Accent>
          </h2>
        </div>

        <ol className="mt-12 rounded-[20px] bg-white px-6 sm:px-8" role="list" data-id="element-46" data-mp="2n00r8ffahaw8">
          {bonuses.map(bonus => <li key={bonus.number} className="grid gap-1 border-b border-brand-charcoal/10 py-5 last:border-b-0 sm:grid-cols-[110px_1fr] sm:gap-6" data-id="element-47" data-mp="1k6sgsqvk42w6">
              <p className="pt-0.5 font-body text-[11px] font-bold uppercase tracking-[0.18em] text-brand-plum" data-id="element-48" data-mp="1txwwjst23rs2">
                {bonus.number}
              </p>
              <h3 className="font-body text-[15px] font-semibold leading-snug text-brand-charcoal" data-id="element-49" data-mp="1p0wqhhw7ip0y">{bonus.title}</h3>
            </li>)}
        </ol>

        <p className="mx-auto mt-10 max-w-2xl text-center text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-50" data-mp="x8pi14quuixn">
          Les bonus complètent votre bibliothèque.{' '}
          <strong className="font-semibold text-brand-charcoal" data-id="element-51" data-mp="167jbim8w2t6z">
            Les 6 volumes restent le cœur de Makeup Instructor Ready.
          </strong>
        </p>
      </div>
    </section>;
}